var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoryIconNormalColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49999 6.75H10.6667C11.3333 6.75 11.75 6 11.3333 5.5L8.24999 0.416664C7.91666 -0.0833359 7.16666 -0.0833359 6.83333 0.416664L3.74999 5.5C3.41666 6.08333 3.83333 6.75 4.49999 6.75V6.75Z",
    fill: "#ABB5BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 15.9167C14.2377 15.9167 15.9167 14.2377 15.9167 12.1667C15.9167 10.0956 14.2377 8.41666 12.1667 8.41666C10.0956 8.41666 8.41666 10.0956 8.41666 12.1667C8.41666 14.2377 10.0956 15.9167 12.1667 15.9167Z",
    fill: "#ABB5BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91666 8.83333H0.916662C0.499995 8.83333 0.0833282 9.24999 0.0833282 9.66666V14.6667C0.0833282 15.0833 0.499995 15.5 0.916662 15.5H5.91666C6.33333 15.5 6.74999 15.0833 6.74999 14.6667V9.66666C6.74999 9.24999 6.33333 8.83333 5.91666 8.83333Z",
    fill: "#ABB5BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIconNormalColor);
export default __webpack_public_path__ + "static/media/category-icon-normal-color.8131c1b119af8b49802d31b00fb038e5.svg";
export { ForwardRef as ReactComponent };